import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import DenaliLogo from './DenaliLogo'

const useStyles = makeStyles(() => ({
  restricted: {
    display: 'flex',
    width: '100%',
    height: '75vh',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
}))

const NotFoundView = () => {
  const classes = useStyles()
  return (
    <FadeIn>
      <article className={classes.restricted}>
        <header className='flex flex-col gap-md justify-center items-center'>
          <DenaliLogo />
          <div className='font-serif font-size-2xl font-bold'>Sorry, wrong turn.</div>
          <div className='font-serif font-size-md'>Some features might still be under construction.</div>
        </header>
        <footer className='mt-5'>
          <Link className='font-sans font-size-md' style={{ color: 'var(--dai-color-accent)' }} to='/denali-ai'>Go Home</Link>
        </footer>
      </article>
    </FadeIn>
  )
}

export default NotFoundView
